<template>
  <nav class="mt-4 mb-4 d-print-none" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/home" title="Home">Home</router-link>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        {{ textItem }}
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',

  props: {
    textItem: {
      type: String,
      required: true,
    },
  },
}
</script>
